export default __webpack_public_path__ + "static/media/Standard02.b04d91be.png";